import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { QueryFilter, QUERY_FILTER_CONSULTING_PUBLISHER } from 'src/component/shared';

import { Paper, Typography, LinearProgress } from '@material-ui/core';

import { Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, BarChart, Tooltip, Legend } from 'recharts';
import { NumberLessBRL } from '../../../../services';

// tslint:disable-next-line:no-empty-interface
export interface IConsultingPublisherCategoryProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IConsultingPublisherCategoryState {
    customFilter: {
        isChart: boolean
    },
}

export interface IConsultingPublisherCategoryDataChart {
    category: string;
    origin: string;

    market_value: number;
    market_value_label?: string;

    value: number;
    value_label?: string;
}

const CONSULTING_PUBLISHER_CATEGORY = gql`
query consultingPublisherCategoryEvolution($customFilter:  ConsultingPublisherCustomFilter) {
    consultingPublisherCategoryEvolution(consultingPublisherCustomFilter: $customFilter) {
        category,
        market_volume,
        origin,
        volume
  }
}
`;

// statless component
const ConsultingPublisherCategoryDataChart = ({ data }: { data: IConsultingPublisherCategoryDataChart[] }) => (
    <ResponsiveContainer width="100%" height={400}>
        <BarChart data={data} margin={{ top: 30, right: 50, left: 14, bottom: 10 }} layout="vertical">
          <CartesianGrid vertical={false} horizontal={false} />
          <XAxis type="number" />
          <YAxis yAxisId="center" type="category" dataKey="category" tick={{fontSize: 10}}/>
          <Tooltip content={<ConsultingPublisherCategoryTooltipData />} />
          <Legend />
          <Bar yAxisId="center" name='Mercado' dataKey='market_value' barSize={20} fill='#323232'/>
          <Bar yAxisId="center" name='Fornecedor' dataKey='value' barSize={20} fill='#00aeef'/>
       </BarChart>
    </ResponsiveContainer>
);

// statless component
const ConsultingPublisherCategoryTooltipData = (props: any) => {

    let content;
    props.payload !== null &&  props.payload !== 0 &&  props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (
        <div className="tooltip-box">
            <table>
                <tbody>
                    <tr className="tooltip-text">
                        <td className="tooltip-title">Volume {content && ' '+content.origin}:</td>
                        <td className="tooltip-content">{content && content.value_label}</td>
                    </tr>
                    <tr className="tooltip-text">
                        <td className="tooltip-title">Volume Mercado:</td>
                        <td className="tooltip-content">{content && content.market_value_label}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
};

const dataFilled = (data: any) => {
    return data && data.consultingPublisherCategoryEvolution && !!data.consultingPublisherCategoryEvolution.length
}

export class ConsultingPublisherCategory extends React.Component<IConsultingPublisherCategoryProps, IConsultingPublisherCategoryState> {
    constructor(props: IConsultingPublisherCategoryProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
        }
    }
    public render() {
        const jsonFilter : any = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };

        return (
            <Query query={QUERY_FILTER_CONSULTING_PUBLISHER} notifyOnNetworkStatusChange={true}  >
            {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => (
                <Query query={CONSULTING_PUBLISHER_CATEGORY} variables={QueryFilter.getFilterConsultingPublisher(clientC, jsonFilter, [], false)}>
                {({ loading, error, data, client }) => {
                    return (
                        <Paper className="publisher-sale-block panel-block" >
                            <Typography variant="headline" className="panel-title" component="title">
                                Categorias x Mercado
                            </Typography>
                            {
                                loading
                                ?
                                <LinearProgress />
                                :
                                (
                                    dataFilled(data)
                                    ?
                                    (<ConsultingPublisherCategoryDataChart data={this.consultingPublisherCategoryDataChartMap(data.consultingPublisherCategoryEvolution)} />)
                                    :
                                    (<Typography variant="body2" className="comparative" component="p">
                                        Não há informações de vendas
                                    </Typography>)
                                )
                            }
                        </Paper>
                    );
                }}
                </Query>
            )}
            </Query>
        );
    }

    private consultingPublisherCategoryDataChartMap = (data: any[]) => {
        const mappedData: IConsultingPublisherCategoryDataChart[] = [];

        data.forEach(e => {
            const item: IConsultingPublisherCategoryDataChart = {
                category:               e.category,
                origin:                 e.origin,

                market_value:           Number(e.market_volume.toString()),
                market_value_label:     NumberLessBRL(e.market_volume.toString()),

                value:                  Number(e.volume.toString()),
                value_label:            NumberLessBRL(e.volume.toString())
            };

            mappedData.push(item);
        });
        return mappedData;
    }
}



// WEBPACK FOOTER //
// ./src/component/consulting/publisher/categoryEvolution/ConsultingPublisherCategory.tsx